var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniLibrary03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#5BA89F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_15160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.304688,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_15160)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.973 242.053V222.256H189.738C194.236 222.256 196.82 225.031 196.82 228.928C196.82 232.879 194.195 235.6 189.629 235.6H186.074V242.053H181.973ZM186.074 232.291H188.973C191.406 232.291 192.596 230.924 192.582 228.928C192.596 226.959 191.406 225.633 188.973 225.619H186.074V232.291ZM200.785 242.299C199.5 242.299 198.461 241.273 198.488 240.002C198.461 238.744 199.5 237.719 200.785 237.732C202.002 237.719 203.055 238.744 203.055 240.002C203.055 241.273 202.002 242.299 200.785 242.299ZM206.391 242.053V222.256H214.156C218.654 222.256 221.238 225.031 221.238 228.928C221.238 232.879 218.613 235.6 214.047 235.6H210.492V242.053H206.391ZM210.492 232.291H213.391C215.824 232.291 217.014 230.924 217 228.928C217.014 226.959 215.824 225.633 213.391 225.619H210.492V232.291ZM227.801 222.256V242.053H223.754V222.256H227.801ZM237.672 242.354C233.119 242.34 230.33 239.4 230.344 234.697C230.33 230.117 233.16 227.014 237.508 227.014C241.404 227.014 244.48 229.475 244.48 234.533V235.682H234.336C234.336 237.924 235.662 239.305 237.754 239.318C239.135 239.305 240.119 238.703 240.516 237.814H244.371C243.797 240.562 241.336 242.34 237.672 242.354ZM234.336 233.139H240.652C240.639 231.334 239.395 230.035 237.59 230.049C235.73 230.035 234.418 231.43 234.336 233.139Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6973 150.137L142.751 107.525L255.745 169.768L166.691 212.379L53.6973 150.137Z",
    fill: "#331712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.197 50.6172V51.1151C139.197 51.1151 142.664 53.758 144.071 55.2806L144.665 55.1944V54.7635L139.197 50.6172Z",
    fill: "#58271E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.791 58.408V59.1932C128.791 59.1932 141.919 59.5571 148.46 65.5706V64.3737C148.46 64.3737 142.666 58.6953 128.791 58.3984V58.408Z",
    fill: "#58271E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.198 50.6155C154.27 50.1655 162.562 57.5292 162.562 57.5292L148.429 64.3854C141.553 58.6208 128.779 58.4102 128.779 58.4102C128.779 58.4102 134.889 55.097 144.282 54.8959C144.282 54.8959 143.162 53.8042 141.888 52.7413C141.228 52.1955 139.198 50.6155 139.198 50.6155Z",
    fill: "#B54735"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.266 85.9766L291.174 148.698V152.528L176.266 89.3281V85.9766Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.173 110.397V106.566L178.18 44.3242L174.35 46.2394L291.173 110.397Z",
    fill: "#283B68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 132.899L178.183 90.2871L291.176 152.529L202.122 195.141L89.1289 132.899Z",
    fill: "#4966A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 129.073L178.183 86.4609L291.176 148.703L202.122 191.794L89.1289 129.073Z",
    fill: "#233457"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 90.7662L178.183 48.1543L291.176 110.396L202.122 153.008L89.1289 90.7662Z",
    fill: "#3B548D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 86.9362L178.183 44.3242L291.176 106.566L202.122 149.178L89.1289 86.9362Z",
    fill: "#FFBAAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 86.9362L178.183 44.3242L291.176 106.566L202.122 149.178L89.1289 86.9362Z",
    fill: "url(#paint0_linear_502_15160)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 86.9355V133.378L202.122 195.62V149.178L89.1289 86.9355Z",
    fill: "#9A4E41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1289 86.9355V133.378L202.122 195.62V149.178L89.1289 86.9355Z",
    fill: "url(#paint1_linear_502_15160)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M290.215 149.178V110.396L202.598 151.572V191.79L290.215 149.178Z",
    fill: "#E1E8FA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.215 149.178V110.396L202.598 151.572V191.79L290.215 149.178Z",
    fill: "url(#paint2_linear_502_15160)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.175 106.566V110.397L204.515 151.86V190.632L291.175 148.7V152.53L202.121 195.621V149.178L291.175 106.566Z",
    fill: "#7B3428"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_502_15160",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 60,
    width: 78,
    height: 45
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.625 104.077L127.002 91.2747L180.779 60.2207L204.402 73.0234L150.625 104.077Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_502_15160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.402 93.2708C144.316 93.3186 144.239 93.3665 144.143 93.4144L141.51 94.7646L134.883 90.8673L137.507 89.5171C139.729 88.3871 142.123 88.6074 144.067 89.766C145.982 90.8768 146.317 92.1696 144.402 93.2803M127.826 90.8194L147.504 102.396L151.22 100.481L144.804 96.7084L148.021 95.0518C148.184 94.9657 148.347 94.8795 148.5 94.7933C152.129 92.6962 151.679 90.0054 147.906 87.7935C144.028 85.5144 138.934 85.0931 134.864 87.1998L127.836 90.8194",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.116 91.1437C159.072 91.7469 159.187 92.7811 160.413 93.4706C161.648 94.227 163.611 94.342 164.779 93.7387C164.808 93.7195 164.837 93.71 164.865 93.6908C165.871 93.1163 165.775 92.0629 164.549 91.3352C163.295 90.5978 161.322 90.4925 160.231 91.0671C160.183 91.0862 160.145 91.1149 160.106 91.1341",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.522 81.866C166.436 81.9139 166.35 81.9617 166.254 82.0096L163.631 83.3598L156.995 79.4529L159.618 78.1027C161.84 76.9728 164.234 77.193 166.178 78.3517C168.093 79.4625 168.438 80.7552 166.522 81.8564M149.937 79.3954L169.615 90.9821L173.331 89.0669L166.915 85.2941L170.132 83.6375C170.295 83.5513 170.448 83.4651 170.592 83.3885C174.231 81.2914 173.781 78.6007 170.008 76.3791C166.13 74.1001 161.036 73.6787 156.956 75.7758L149.928 79.3954",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.658 71.3024L185.346 82.889L189.004 81.0026L169.326 69.416L165.658 71.3024Z",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.783 69.7801L186.066 72.7294C184.506 71.7335 184.257 70.3738 185.76 69.5024C185.817 69.4641 185.884 69.4353 185.951 69.397C187.57 68.5448 189.983 68.7267 191.793 69.7705M182.475 67.8649C178.952 69.895 179.593 72.9113 184.008 75.4968C188.671 78.2546 194.12 78.6759 198.256 76.5597C198.4 76.4831 198.544 76.4065 198.678 76.3299C201.589 74.6445 201.924 72.5762 199.807 70.7759L196.322 72.5762C196.82 73.2465 196.571 74.0221 195.47 74.6637C195.422 74.6924 195.374 74.7211 195.316 74.7499C193.411 75.717 190.835 75.5255 188.604 74.2136L197.787 69.4832L196.638 68.8129C191.611 65.854 186.373 65.8444 182.849 67.6638C182.715 67.7309 182.59 67.7979 182.466 67.8745",
    fill: "#4972CE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_15160",
    x1: 131.982,
    y1: 75.3224,
    x2: 229.18,
    y2: 92.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BDB3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_15160",
    x1: 89.4255,
    y1: 87.4055,
    x2: 136.185,
    y2: 140.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979729,
    stopColor: "#9A4E41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_15160",
    x1: 216.567,
    y1: 139.42,
    x2: 250.192,
    y2: 170.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLibrary03);
export default __webpack_public_path__ + "static/media/mini_library_03.f63c1b8471fc09c539e5c7976b625066.svg";
export { ForwardRef as ReactComponent };